export default __webpack_public_path__ + "static/media/animoca.26cd3df6.svg";